import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AulaFormLTI } from 'Component/Aula';
import Carregando from 'Component/Carregando';
import { useSubscription } from 'Hook/Subscription';
import { IESDE, LTI } from 'Interface/Aulas';
import Curso from 'Interface/Cursos';
import { salvar } from 'Reducer/Aula';
import {
  useAdicionarAulaAssistidaMutation,
  useGerarEstruturaLTIAulaMutation,
  useRecuperarAulaQuery,
  useRecuperarCursosQuery,
  useRecuperarUrlsIesdeAulaMutation,
  useRecuperarUrlsProprietarioAulaMutation,
} from 'Service';
import { useAppDispatch } from 'Store';

const Processar = (): React.ReactElement => {
  const dispatch = useAppDispatch();
  const navegacao = useNavigate();
  const subscription = useSubscription();
  const { slug = '', id = 0 } = useParams();
  const [processando, setProcessando] = useState<boolean>(true);
  const [dadosLti, setDadosLti] = useState<LTI>();

  const [adicionarAulaAssistida] = useAdicionarAulaAssistidaMutation();
  const [gerarEstruturaLTI] = useGerarEstruturaLTIAulaMutation();
  const [recuperarUrlsIesde] = useRecuperarUrlsIesdeAulaMutation();
  const [recuperarUrlsProprietario] =
    useRecuperarUrlsProprietarioAulaMutation();

  const { data: { cursos: [curso] } = { cursos: [{} as Curso] } } =
    useRecuperarCursosQuery({
      finder: 'slug',
      contain: ['Categorias', 'Modulos.Aulas'],
      options: { slug: { slug: slug } },
    });
  const { data: { aula } = {} } = useRecuperarAulaQuery(
    { id: id, contain: ['UnidadesDeAprendizagem'] },
    { skip: !id }
  );

  useEffect(() => {
    if (subscription === false || (subscription && subscription.status == 0)) {
      navegacao('/estudar/assinar');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription]);

  useEffect(() => {
    if (subscription && subscription.status && curso.id && aula?.id) {
      adicionarAulaAssistida({ aula_id: aula.id }).unwrap();

      setTimeout(() => {
        switch (curso.tecnologia) {
          case 'lti':
            lti();
            break;
          case 'iesde':
            iesde();
            break;
          case 'proprietaria':
            proprietaria();
            break;
        }
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curso, aula, subscription]);

  const lti = async () => {
    if (aula) {
      const lti = (await gerarEstruturaLTI(aula).unwrap()) as unknown as LTI;

      setDadosLti(lti);
      setProcessando(false);
    }
  };

  const iesde = async () => {
    if (aula) {
      const { iesde } = (await recuperarUrlsIesde(
        aula
      ).unwrap()) as unknown as IESDE;

      dispatch(
        salvar({
          urlAula: iesde.aula,
          urlLivro: iesde.livro,
          unidadeDeAprendizagem: undefined,
        })
      );

      navegacao(`/estudar/curso/${curso.slug}/aula/${aula.id}/assistir`);
    }
  };

  const proprietaria = async () => {
    if (aula) {
      const { aula: { unidade_de_aprendizagem } = {} } =
        await recuperarUrlsProprietario(aula).unwrap();

      if (unidade_de_aprendizagem) {
        dispatch(
          salvar({
            urlAula: unidade_de_aprendizagem.video_apple,
            urlLivro: undefined,
            unidadeDeAprendizagem: unidade_de_aprendizagem,
          })
        );

        navegacao(`/estudar/curso/${curso.slug}/aula/${aula.id}/assistir`);
      }
    }
  };

  return (
    <div className="animate__animated animate__fadeIn">
      <div
        className="container px-4 d-flex justify-content-center align-items-center flex-column"
        style={{ height: window.innerHeight - 150 }}
      >
        {processando && (
          <Carregando
            titulo="Aguarde enquanto estamos preparando tudo..."
            subtitulo="Você será redirecionado automaticamente para sua aula."
          />
        )}
        {dadosLti && <AulaFormLTI {...dadosLti} />}
      </div>
    </div>
  );
};

export default Processar;
